import Make from './make'
import { delay } from './helpers'

const make = Make('billing/')

export const getAvailableSubscriptions = async (): Promise<any[]> => {
  const req = await make.get<{ plans: any[] }>({
    endpoint: 'get-available-subscriptions',
  })

  if (!req.success) {
    return []
  }

  return req?.res?.data?.plans || []
}

export const checkBillingState = async (): Promise<any> => {
  const req = await make.get<{ billingState?: 'preSetup' | 'active' }>({
    endpoint: 'get-billing-detail',
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

export const pollBillingState = async (
  callback?: (res: boolean) => void,
): Promise<boolean> => {
  const billingState = await checkBillingState()

  if (billingState && callback) {
    callback(billingState)
    return billingState
  }

  if (billingState) {
    return billingState
  }

  await delay(3000)

  return pollBillingState()
}

interface RemoveAccount {
  accountID: string
}

export const removeAccount = async (data: RemoveAccount): Promise<boolean> => {
  const req = await make.delete({
    endpoint: `remove-account/${data.accountID}`,
    data,
  })

  if (!req.success) {
    return false
  }

  return true
}

export interface BillingStatus {
  billingDetail: {
    billingEmail: string
    billingState: string
    code: number
    delete_url: string
    next_bill_date: string
    subscription_plan_name: string
    token: string
    update_url: string
  }
}

export const getBillingState = async (): Promise<BillingStatus | null> => {
  const req = await make.get<BillingStatus>({
    endpoint: 'get-billing-detail',
  })

  if (!req.success) {
    return null
  }

  return req?.res?.data || null
}

export const getEnterpriseBillingState = async (): Promise<EnterpriseBillingDetails | null> => {
  const req = await make.get<EnterpriseBillingDetails>({
    endpoint: 'get-enterprise-billing-details',
  })

  if (!req.success) {
    return null
  }

  return req?.res?.data || null
}

export const updateEnterpriseBillingState = async (
  data: EnterpriseBillingDetails,
): Promise<boolean> => {
  const req = await make.post({
    endpoint: 'update-enterprise-billing-details',
    data,
  })

  if (!req.success) {
    return false
  }
  return true
}

export interface BillingHistory {
  billingHistory: {
    date: string
    receipt_url: string
  }[]
}

export const getBillingHistory = async (): Promise<BillingHistory | null> => {
  const req = await make.get<BillingHistory>({
    endpoint: 'get-payment-history',
  })

  if (!req.success) {
    return null
  }

  return req?.res?.data || null
}
